var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMrSquareMessage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 115.501,
    height: 63.749,
    viewBox: "0 0 115.501 63.749",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4727",
    "data-name": "Group 4727",
    transform: "translate(-361.333 -663.257)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4725",
    "data-name": "Group 4725",
    transform: "translate(361.333 663.758)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4721",
    "data-name": "Group 4721"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3551",
    "data-name": "Path 3551",
    d: "M417.389,670.785v49.193H368.34V670.785h49.049m7.007-7.028H361.333v63.248H424.4V663.757Z",
    transform: "translate(-361.333 -663.757)",
    fill: "#464af0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4722",
    "data-name": "Group 4722",
    transform: "translate(38.178 18.871)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3552",
    "data-name": "Path 3552",
    d: "M389.357,671.813H377.679v6.544l8.824,2.826-8.824,3.416v5.954h11.678v-18.74Z",
    transform: "translate(-377.679 -671.813)",
    fill: "#464af0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4723",
    "data-name": "Group 4723",
    transform: "translate(14.113 18.792)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3553",
    "data-name": "Path 3553",
    d: "M379.054,671.779H367.375v6.544l8.824,2.826-8.824,3.416v5.954h11.678v-18.74Z",
    transform: "translate(-367.375 -671.779)",
    fill: "#464af0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4724",
    "data-name": "Group 4724",
    transform: "translate(23.055 38.455)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3554",
    "data-name": "Path 3554",
    d: "M377.41,685.238a25.974,25.974,0,0,1-6.206-.691l.6-2.265c.084.021,8.8,2.263,16.94-2.108l1.1,2.061A26.266,26.266,0,0,1,377.41,685.238Z",
    transform: "translate(-371.204 -680.173)",
    fill: "#464af0"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_2",
    "data-name": "Subtraction 2",
    d: "M0,31.626v0L.026,21.084V0H42.044V21.084H13.1L0,31.624Zm29.195-24.6v7.03H36.2V7.027Zm-11.678,0v7.03h7.008V7.027Zm-11.678,0v7.03h7.007V7.027Z",
    transform: "translate(434.289 663.756)",
    fill: "#464af0",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMrSquareMessage);
export default __webpack_public_path__ + "static/media/mr_square_message.45c95d731087f373ceceda50db0ed181.svg";
export { ForwardRef as ReactComponent };